import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getResponseData } from '../../utils/apiResponseHandler';
import { subscriptionsService } from '../../services';

export const fetchMySubscription = createAsyncThunk('subscription/fetchMine', async () => {
  const d = await subscriptionsService.mine();
  if (!d.success) throw new Error(d.message || 'Failed to fetch subscription');
  return getResponseData(d, 'subscription');
});

export const createOrSwitchSubscription = createAsyncThunk(
  'subscription/createOrSwitch',
  async payload => {
    const d = await subscriptionsService.create(payload);
    if (!d.success) throw new Error(d.message || 'Failed to create subscription');
    return getResponseData(d, 'subscription');
  }
);

const subscriptionSlice = createSlice({
  name: 'subscription',
  initialState: { current: null, loading: false, error: null, selectedPlan: null },
  reducers: {
    updateCredits(state, action) {
      if (state.current) {
        state.current.credits = action.payload;
      }
    },
    setSelectedPlan(state, action) {
      state.selectedPlan = action.payload || null;
    },
    clearSelectedPlan(state) {
      state.selectedPlan = null;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchMySubscription.pending, s => {
        s.loading = true;
        s.error = null;
      })
      .addCase(fetchMySubscription.fulfilled, (s, a) => {
        s.loading = false;
        s.current = a.payload;
      })
      .addCase(fetchMySubscription.rejected, (s, a) => {
        s.loading = false;
        s.error = a.error.message;
      })
      .addCase(createOrSwitchSubscription.fulfilled, (s, a) => {
        s.current = a.payload;
      });
  },
});

export const selectSubscription = state => state.subscription.current;
export const selectSelectedPlan = state => state.subscription.selectedPlan;
export const { setSelectedPlan, clearSelectedPlan, updateCredits } = subscriptionSlice.actions;
export default subscriptionSlice.reducer;
